import { TagColor } from "../state/types";

export const TAG_COLORS: TagColor[] = [
  "green",
  "yellow",
  "orange",
  "red",
  "purple",
  "blue",
  "sky",
  "lime",
  "pink",
  "gray",
];

export const tagBg: Record<TagColor, string> = {
  green: "bg-emerald-400",
  yellow: "bg-yellow-300",
  orange: "bg-orange-400",
  red: "bg-red-400",
  purple: "bg-purple-400",
  blue: "bg-blue-400",
  sky: "bg-sky-400",
  lime: "bg-lime-400",
  pink: "bg-pink-400",
  gray: "bg-gray-400",
};

export const tagHover: Record<TagColor, string> = {
  green: "hover:bg-emerald-500",
  yellow: "hover:bg-yellow-400",
  orange: "hover:bg-orange-500",
  red: "hover:bg-red-500",
  purple: "hover:bg-purple-500",
  blue: "hover:bg-blue-500",
  sky: "hover:bg-sky-500",
  lime: "hover:bg-lime-500",
  pink: "hover:bg-pink-500",
  gray: "hover:bg-gray-500",
};

export const tagText: Record<TagColor, string> = {
  green: "text-white",
  yellow: "text-black",
  orange: "text-white",
  red: "text-white",
  purple: "text-white",
  blue: "text-white",
  sky: "text-white",
  lime: "text-black",
  pink: "text-white",
  gray: "text-white",
};

export const tagHex: Record<TagColor, string> = {
  green: "#34d399",
  yellow: "#fde047",
  orange: "#fb923c",
  red: "#f87171",
  purple: "#c084fc",
  blue: "#60a5fa",
  sky: "#38bdf8",
  lime: "#a3e635",
  pink: "#f472b6",
  gray: "#9ca3af",
};

const hexToRgb = (hex: string): [number, number, number] => {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

export const tagFillColor = (color: TagColor, alpha: number): string => {
  const [r, g, b] = hexToRgb(tagHex[color]);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
